export default __webpack_public_path__ + "static/media/Shape 42.1639a940.svg";